import styled from 'styled-components';
import { Collapse } from 'antd';

// UI change for antd collapse using styled component
const EbzCollapse = styled(Collapse)`
  .ant-collapse-item-active > .ant-collapse-header {
    background-color: #effff9;
  }

  .ant-collapse-item:last-child,
  .ant-collapse-item {
    border: 1px solid #dedede;
    border-left: 0px;
    border-right: 0px;
  }

  .ant-collapse-item-active {
    border-bottom: 0px !important;
    border-top: 0px !important;
  }

  .ant-collapse-item:first-child {
    border-top: 0px;
  }
`;

export default EbzCollapse;
